import styled from "styled-components"

const Spacer = styled.div.attrs<{widthInPx?: number, heightInPx?: number}>(p => ({
    style: {
        width: p.widthInPx ? p.widthInPx + "px" : undefined,
        height: p.heightInPx ? p.heightInPx + "px" : undefined,
    }
}))``

export default Spacer